
<template>
  <section class="sm-upper">
    <div class="sm-wrap">
      <div class="sm-upper__user">
        <div 
          class="sm-upper__user-avatar" 
          @click="$refs.input_file.click()"
        >
          <img-loader 
            v-if="avatar"
            :src="avatar" 
          />
          <include-svg
            v-else
            :name="'icon-no-avatar'"
          />

          <include-svg :name="'icon-edit'" />
          <input 
            ref="input_file"
            hidden 
            type="file" 
            name="image" 
            @change="uploadFile" 
          />
        </div>
        <div class="sm-upper__user-flex">
          <div class="sm-upper__user-flex-row">
            <h4>{{userAccount.first_name}}&nbsp;{{userAccount.last_name}}</h4>
            <div 
              class="sm-upper__user-status sm-txt-capitalize"
              :class="isActive ? 'active' : ''"
            >
              <span v-if="isActive">Active</span>
              <span v-else>Inactive</span>
            </div>
          </div>
          <span 
            v-if="userPlan.plan_type == 'business' && userAccount.company_name"
            class="sm-txt-upper"
          >{{userAccount.company_name}}</span>
          <span
            v-if="!userAccount.auto_renew && userAccount.activated_on && userAccount.subscription_expires_on"
          ><b class="sm-txt-strong">Subscription will end at: </b>{{userAccount.subscription_expires_on | moment('D MMM, YYYY')}}</span>
        </div>
        <a 
          href="#"
          class="sm-upper__logout"
          @click.prevent="logOut()"
        >
          <include-svg :name="'icon-logout'" />
          <span>Log out</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import imageStore from '@/utils/image-store';
import {IsRightFileType} from "@/utils/general-data";
import ImgLoader from '@/components/ImgLoader';

export default {
  name: 'account-top',
  components: {
    'img-loader': ImgLoader
  },
  data() {
    return {
      image: '',
      userPlan: {}
    }
  },
  created(){
    if (this.userAccount.plan_id)
      this.getPlan(this.userAccount.plan_id)
        .then(res => {
          this.userPlan = res;
    });
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
      form1583Signed: 'account/form1583Signed',
      //provider: 'provider'
    }),
    avatar() {
      let path;

      if (this.image) {
        path = this.image;
      } else if (this.userAccount.image_url) {
        path = imageStore(this.userAccount.image_url);
      } else {
        path = null;
      }

      return path;
    },
    isActive() {
      if(this.userAccount.type == "AdditionalRecipient"){
        return this.userAccount.additional_recipient_status != "inactive"
      }
      return /*this.form1583Signed && */this.userAccount.can_access_mail_manager;
    }
  },
  methods: {
    ...mapActions({
      updateUser: "account/updateUser",
      getPlan: 'plans/getPlan'
    }),
    isRightFileType: IsRightFileType,
    logOut() {
      this.$router.push('/login');
    },
    uploadFile(e) {
      if (e.target.files.length === 0) 
        return false;

      const target = e.target;
      const file = target.files[0];

      if (!this.isRightFileType(file, ['image']))
        return false;

      // update account
      let formData = new FormData();
      formData.append('account[image]', file);

      this.updateUser(formData);

      // create poster
      this.image = this.createPoster(file);
    },
    createPoster(file) {
      if (!file) 
        return false;

      const maxWeight = 25165824;

      let size = file.size;

      if (size > maxWeight) 
        return false;

      return URL.createObjectURL(file);
    },
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/customer/account/_upper.scss';
</style>